import { render } from "./DocumentListItem.vue?vue&type=template&id=90eb1be2&scoped=true"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"

import "./DocumentListItem.vue?vue&type=style&index=0&id=90eb1be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90eb1be2"]])

export default __exports__